import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Screen } from '../../components';
import './PdfDocument.scss';
import { Document } from '../../components/Document';
import { useState, useCallback, useMemo } from 'react';
import { IconArrowsMaximize, IconArrowsMinimize } from '@tabler/icons-react';

export const DocsViewer = () => {
  const { fileKey: fileKeyParam } = useParams();
  const [searchParams] = useSearchParams();
  const canDownload = useMemo(() => searchParams.get('isEnabled') === 'true', [searchParams]);
  const contentId = useMemo(() => searchParams.get('contentId') ?? undefined, [searchParams]);

  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);

  const fileKey = useMemo(() => fileKeyParam ?? '', [fileKeyParam]);

  const documentName = useMemo(
    () => decodeURIComponent(searchParams.get('title') ?? 'Documento'),
    [searchParams]
  );

  const header = useMemo(() => (
    <button
      type="button"
      onClick={toggleFullscreen}
      className="fullscreen-doc cursor-pointer"
      aria-label={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}
    >
      {isFullscreen ? <IconArrowsMinimize size={20} /> : <IconArrowsMaximize size={20} />}
    </button>
  ), [isFullscreen, toggleFullscreen]);

  const documentProps = useMemo(() => ({
    canDownload,
    contentId,
    fileKey,
    name: documentName,
    header
  }), [canDownload, contentId, fileKey, documentName, header]);

  if (isFullscreen) {
    return <Document {...documentProps} />;
  }

  return (
    <Screen id="SubjectViewer" title={documentName}>
      <Box>
        <Document {...documentProps} />
      </Box>
    </Screen>
  );
};
